import * as $options from 'gleam:redraw_toastify/internal/options.ffi'
import * as toastify from 'react-toastify'

export const toast = content => toastify.toast(content)
export const dismiss = toastId => toastify.toast.dismiss(toastId)
export const isActive = toastId => toastify.toast.isActive(toastId)
export const clearWaitingQueue = () => toastify.toast.clearWaitingQueue()
export const done = toastId => toastify.toast.done(toastId)
export const play = toastId => toastify.toast.play(toastId)
export const pause = toastId => toastify.toast.pause(toastId)

export function custom(options, content) {
  const options_ = convertOptions(options)
  return toastify.toast(content, options_)
}

export function update(toastId, options) {
  const options_ = convertOptions(options)
  return toastify.toast.update(toastId, options_)
}

// prettier-ignore
function convertOptions(options) {
  if (!options) return
  const opts = {}
  $options.addIf(opts, options.toast_id, 'toastId')
  $options.addIf(opts, options.type_, 'type', $options.convertType)
  $options.addIf(opts, options.position, 'position', $options.convertPosition)
  $options.addIf(opts, options.on_open, 'onOpen')
  $options.addIf(opts, options.on_close, 'onClose')
  $options.addIf(opts, options.auto_close, 'autoClose', $options.convertAutoclose)
  $options.addIf(opts, options.close_button, 'closeButton', $options.convertCloseButton)
  $options.addIf(opts, options.transition, 'transition')
  $options.addIf(opts, options.hide_progress_bar, 'hideProgressBar')
  $options.addIf(opts, options.pause_on_hover, 'pauseOnHover')
  $options.addIf(opts, options.pause_on_focus_loss, 'pauseOnFocusLoss')
  $options.addIf(opts, options.close_on_click, 'closeOnClick')
  $options.addIf(opts, options.class_name, 'className')
  $options.addIf(opts, options.style, 'style', $options.convertStyle)
  $options.addIf(opts, options.progress_class_name, 'progressClassName')
  $options.addIf(opts, options.draggable, 'draggable')
  $options.addIf(opts, options.draggable_percent, 'draggablePercent')
  $options.addIf(opts, options.draggable_direction, 'draggableDirection', $options.convertDraggableDirection)
  $options.addIf(opts, options.container_id, 'containerId')
  $options.addIf(opts, options.role, 'role')
  $options.addIf(opts, options.delay, 'delay')
  $options.addIf(opts, options.on_click, 'onClick')
  $options.addIf(opts, options.render, 'render')
  $options.addIf(opts, options.is_loading, 'isLoading')
  return opts
}
